<kendo-dialog
	title="Online Training"
	*ngIf="dialogOpened"
	(close)="close('dialog')"
	class="kpa-safetyvideo-dialog">
	<iframe
		#iframe
		class="safety-video-iframe"
		[src]="contentURL"
		allow="encrypted-media *;accelerometer; autoplay; gyroscope; picture-in-picture"
		frameborder="0"
		allowfullscreen></iframe>
	<kendo-dialog-actions *ngIf="isMarcom">
		<div
			class="attestation"
			*ngIf="!showButtons">
			<label>
				<input
					type="checkbox"
					[(ngModel)]="isCheckboxChecked"
					(change)="onCheckboxChange()" />
				Training Complete
			</label>
		</div>
		<div
			class="attestation confirmation"
			*ngIf="showButtons">
			<p>Please confirm you have watched and understood the training</p>
			<div class="confirmation-buttons">
				<button
					kendoButton
					kpaKendoButton="primary"
					(click)="onYesClick()">
					Yes
				</button>
				&nbsp;
				<button
					kendoButton
					kpaKendoButton="secondary"
					(click)="onNoClick()">
					No
				</button>
			</div>
		</div>
	</kendo-dialog-actions>
</kendo-dialog>
